import { render, staticRenderFns } from "./OfficeDashboard.vue?vue&type=template&id=fb37775e&"
import script from "./OfficeDashboard.vue?vue&type=script&lang=ts&"
export * from "./OfficeDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports